export const I18n = {
	'en': {
		modal : {
			uploadUserFile: 'Upload file with users',
			upload: 'Upload',
			delete: 'Delete',
			sure: 'Are you sure ?',
			cancel: 'Cancel',
			save: 'Save',
			fileFormat: 'File format',
			fileTooltipText: `File format - csv.
				Fields:
				Email (Login),
				User name,
				Sales point name,
				Phone number.
				Divider - comma.`,
			operatorFileTooltipText: `File format - csv.
				Fields:
				Email (Login),
				User name,
				Phone number,
				Visible sales point names.
				Dividers: comma to separate columns,
				Semicolon to separate elements in column.`,
			add_edit_user: 'Add / Edit user',
			email: 'Email',
			mail_login: 'Email (Login)',
			name: 'Name',
			companyName: 'Company',
			passwd: 'Password',
			repeatPassword: 'Repeat password',
			phoneNumber: 'Phone number',
			status: 'Status',
			statusPending: 'Pending',
			statusBlocked: 'Blocked',
			statusActive: 'Active',
			chooseRole: 'Choose role',
			needToPasswdChange: 'Should change the password',
			userAttributes: 'User attributes',
			resetPassword: 'Reset Password',
		},
		userList_title: 'User List',
		status: 'Status',
		statusAll: 'Status (all)',
		all: 'All',
		statusPending: 'Pending',
		statusBlocked: 'Blocked',
		statusActive: 'Active',
		noStatus: 'None',
		role: 'Role',
		roleAll: 'Role (all)',
		//order: 'Sorting',
		roleGuest: 'Guest',
		roleUser: 'User',
		roleCompanyAdmin: 'Admin',
		roleSuperAdmin: 'Super admin',
		company: 'Company',
		visibleSalesPoints: 'Visible sales points',
		resetFilters: 'Reset filters',
		resetPassword: 'Reset Password',
		addUser: 'Add user',
		newUser: 'New user',
		packageCreation: 'Package creation',
		searchPlaceholder: 'Search...',
		name: 'Name',
		email: 'Email',
		asc: 'Ascending',
		desc: 'Descending',
		lastActivity: 'Last Active',
	},
	'ru': {
		modal : {
			uploadUserFile: 'Загрузка файла пользователей',
			upload: 'Загрузить',
			delete: 'Удалить',
			sure: 'Вы уверены ?',
			cancel: 'Отмена',
			save: 'Сохранить',
			fileFormat: 'Формат файла',
			fileTooltipText: `Формат файла csv.
				Поля:
				Email (он же логин),
				Имя пользователя,
				Наименование торговой точки,
				Номер телефона.
				Разделитель - запятая.`,
			operatorFileTooltipText: `Формат файла csv.
				Поля:
				Email (он же логин),
				Имя пользователя,
				Номер телефона,				
				Наименование видимых торговых точек.
				Разделители: запятая для разделения столбцов,
				Точка с запятой для разделения элементов в столбце`,
			add_edit_user: 'Добавить / Изменить пользователя',
			email: 'Email address',
			mail_login: 'Почта (Логин)',
			name: 'Имя',
			companyName: 'Организация',
			passwd: 'passwd',
			repeatPassword: 'Повторить пароль',
			phoneNumber: 'Номер телефона',
			status: 'Статус',
			statusPending: 'В ожидании',
			statusBlocked: 'Заблокирован',
			statusActive: 'Активный',
			chooseRole: 'Выбор роли',
			needToPasswdChange: 'Необходимо сменить пароль',
			resetPassword: 'Сбросить пароль',
			userAttributes: 'Атрибуты пользователя',
		},
		userList_title: 'Список пользователей',
		status: 'Статус',
		statusAll: 'Статус (все)',
		all: 'Все',
		statusPending: 'В ожидании',
		statusBlocked: 'Заблокирован',
		statusActive: 'Активный',
		noStatus: 'Не определен',
		role: 'Роль',
		roleAll: 'Роль (все)',
		lastActivity: 'Активность',
		roleGuest: 'Гость',
		roleUser: 'Пользователь',
		roleCompanyAdmin: 'Администратор',
		roleSuperAdmin: 'Супер админ',
		company: 'Компания',
		visibleSalesPoints: 'Видимые торгорые точки',
		resetFilters: 'Сбросить фильтры',
		addUser: 'Добавить пользователя',
		newUser: 'Новый пользователь',
		packageCreation: 'Пакетное создание',
		searchPlaceholder: 'Поиск...',
		name: 'Имя',
		email: 'Почта',
		asc: 'По возрастанию',
		desc: 'По убыванию'
	},
	'sk': {
		modal : {
			uploadUserFile: 'Nahrať súbor s používateľmi',
			upload: 'Nahrať',
			delete: 'Vymazať',
			sure: 'Si si istý ?',
			cancel: 'Zrušiť',
			save: 'Uložiť',
			fileFormat: 'Formát súboru',
			fileTooltipText: `Formát súboru - csv.
 				odbory:
 					Email (Login)
 					užívateľské meno
 					Názov traiders point,
 					Telefónne číslo.
 					Delič - čiarka.`,
			operatorFileTooltipText: `File format - csv.
				Fields:
				Email (Login),
				User name,
				Phone number,
				Visible sales point names.
				Dividers: comma to separate columns,
				Semicolon to separate elements in column.`,
			add_edit_user: 'Pridať / Upraviť užívateľa',
			email: 'E-mail',
			mail_login: 'Email (Login)',
			name: 'Názov',
			companyName: 'Spoločnosť',
			passwd: 'Heslo',
			repeatPassword: 'Zopakujte heslo',
			phoneNumber: 'Telefónne číslo',
			status: 'Postavenie',
			statusPending: 'Nevykonaného',
			statusBlocked: 'Upchatý',
			statusActive: 'Aktívny',
			chooseRole: 'Vyberte si úlohu',
			needToPasswdChange: 'Mali zmeniť heslo',
			resetPassword: 'Obnoviť heslo',
			userAttributes: 'Atribúty užívateľa',
		},
		userList_title: 'Zoznam užívateľov',
		status: 'Postavenie',
		statusAll: 'Všetko',
		all: 'Všetko',
		statusPending: 'Nevykonaného',
		statusBlocked: 'Upchatý',
		statusActive: 'Aktívny',
		noStatus: 'Nikto',
		role: 'úloha',
		roleAll: 'úloha (všetko)',
		lastActivity: 'Aktivita',
		roleGuest: 'Hosť',
		roleUser: 'Užívateľ',
		roleCompanyAdmin: 'Admin',
		roleSuperAdmin: 'Super admin',
		company: 'Spoločnosť',
		visibleSalesPoints: 'Viditeľné sales points',
		resetFilters: 'Resetu filtre',
		addUser: 'Pridať užívateľa',
		newUser: 'Nový užívateľ',
		packageCreation: 'Vytvorenie balíček',
		searchPlaceholder: 'Vyhľadávanie...',
		name: 'Názov',
		email: 'E-mail',
		asc: 'Stúpajúca',
		desc: 'Klesajúci'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/users/index.js